import { alpha, Box, Button, Typography, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPriceLimit } from '../../api/subscriptions';

const SubscriptionBox = ({
  item,
  redirectToOrder,
  login,
  subscribeAndOrder,
}) => {
  const [limitData, setLimitCounter] = useState({
    remaining: 0,
    useLimit: true,
  });
  const theme = useTheme();
  const navigate = useNavigate();
  function onButtonClick() {
    localStorage.setItem('orderItem', JSON.stringify(item));
    if (redirectToOrder) {
      navigate('/order');
    }
    if (login) {
      navigate('/subscribe');
    }
    if (subscribeAndOrder) {
      navigate('/processOrder', { state: { order: item } });
    }
  }
  useEffect(() => {
    getPriceLimit(item.subscription_price_id)
      .then((response) => {
        setLimitCounter(response);
      })
      .catch((error) => {
        console.error('Error fetching price limit:', error);
      });
  }, [item]);

  return (
    <Box
      key={item.subscription_price_id}
      sx={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: { xs: 350, sm: 400 },
        height: 'auto',
        padding: 1,
        border: '1px solid #ccc',
        boxShadow: '0 0 5px rgba(0, 0, 0, 0.1)',
        transition: 'all 0.3s ease-in-out',
        '&:hover': {
          transform: 'scale(1.05)',
          boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
        },
      }}
    >
      {/* PIROS SZALAG */}
      {limitData.useLimit && (
        <Box
          sx={{
            position: 'absolute',
            top: 10,
            right: -25,
            background: alpha(theme.palette.primary.highlight, 0.8),
            color: 'white',
            px: 2,
            py: 0.5,
            fontSize: '0.85rem',
            fontWeight: 700,
            borderRadius: '8px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
            transform: 'rotate(20deg)', // kicsit döntött szalag
            zIndex: 1,
            minWidth: '120px',
            textAlign: 'center',
            pointerEvents: 'none',
          }}
        >
          {limitData.remaining <= 0 ? (
            <Typography
              variant='body2'
              sx={{ fontSize: '0.8rem', textAlign: 'center', flexGrow: 1 }}
            >
              Elfogyott
            </Typography>
          ) : (
            <Typography
              variant='body2'
              sx={{ fontSize: '0.8rem', textAlign: 'center', flexGrow: 1 }}
            >
              Már csak {limitData.remaining} db elérhető
            </Typography>
          )}
        </Box>
      )}
      <Typography variant='h5' sx={{ fontWeight: 600, mb: 1 }}>
        {item.price_details}
      </Typography>

      <Typography
        variant='body2'
        sx={{ fontSize: '0.8rem', textAlign: 'center', flexGrow: 1 }}
        dangerouslySetInnerHTML={{ __html: item.price_descr }}
      />
      <Typography
        sx={{
          fontSize: '1.2rem',
          textAlign: 'center',
          color: theme.palette.primary.highlight,
        }}
        dangerouslySetInnerHTML={{ __html: item.price_highlight }}
      />
      {(!limitData.useLimit || (limitData.useLimit && limitData.remaining)) >
        0 && (
        <Button
          variant='contained'
          color='primary'
          sx={{ mt: 2 }}
          onClick={onButtonClick}
        >
          Ezt választom
        </Button>
      )}
    </Box>
  );
};

export default SubscriptionBox;
